import React from 'react';

import { AppBreakpoint } from 'src/_AppContainer';
import { resolveBp } from '@deloitte-digital-au/dd-breakpoint-container';
import Placeholder from 'core/sitecore/jss-proxy-components/JssPlaceholder';
import LayoutPadding from 'core/components/LayoutPadding';
import { NAMES as PLACEHOLDER_NAMES } from 'core/sitecore/definitions/placeholder-definitions';
import { Main } from 'src/_AppPlaceholders';

import * as vr from 'core/styles/variables';

const PLACEHOLDER = PLACEHOLDER_NAMES.PAGE_LAYOUTS.ONE_COLUMN_MAIN;
const MOBILE_BP = '0,s';

export interface IProps {
	rendering?: object;
	/**
	 * To enable proxy components to pass through their own
	 * placeholder name definitions; e.g. `Dashboard` page template
	 */
	placeholder?: string;
	hasNoMargin?: boolean;
	children: React.ReactNode;
}

const GeneralOneColumn = ({
	rendering,
	placeholder = PLACEHOLDER,
	hasNoMargin,
	...props
}: IProps) => (
	<AppBreakpoint.Consumer>
		{(appBp: string) => {
			const isMobile = resolveBp(MOBILE_BP, appBp);

			return (
				<LayoutPadding>
					<div
						style={{
							margin: hasNoMargin
								? `0`
								: isMobile
								? vr.mobilePageTemplateMargin
								: vr.pageTemplateMargin,
						}}
					>
						{React.Children.count(props.children) > 0 ? (
							props.children
						) : (
							<Main>
								<Placeholder
									key={placeholder}
									name={placeholder}
									rendering={rendering}
								/>
							</Main>
						)}
					</div>
				</LayoutPadding>
			);
		}}
	</AppBreakpoint.Consumer>
);

export default GeneralOneColumn;
